import {SOPutReport} from '../../core/report/so-put-report';
import {ReportCore} from './report.core';
import {SOGetReport} from '../../core/report/so-get-report';
import {FormField, SelectionOption} from 'lionheartland';
import {putReportFormFieldOptions} from './put-report-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutReport extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putReportFormFieldOptions);

  RequestClass = SOPutReport

  constructor(
    public entityCore: ReportCore
  ) {
    super();
    if (putReportFormFieldOptions.project) {
      putReportFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}